import React from 'react';
import { useAppContext } from '../utils/AppContext';
import './PizarraPage.css';

const PizarraPage: React.FC = () => {
  const { config } = useAppContext();
  const pizarraConfig = config.pizarra;

  return (
    <div className="pizarra-page">
      <div className="pizarra-header">
        <h1 className="pizarra-title">{pizarraConfig.title}</h1>
        <h2 className="pizarra-subtitle">{pizarraConfig.subtitle}</h2>
      </div>
      
      <div className="pizarras-container">
        {pizarraConfig.pizarras.map((pizarra) => (
          <div key={pizarra.id} className="pizarra-item">
            {pizarraConfig.showTeamNames && (
              <div 
                className="pizarra-team-name"
                style={{ color: pizarra.color }}
              >
                {pizarra.teamName}
              </div>
            )}
            
            <div className="pizarra-svg-container">
              <img 
                src="/img/pizarra.svg" 
                alt="Pizarra" 
                className="pizarra-svg"
              />
              
              {pizarraConfig.showNumbers && (
                <div 
                  className="pizarra-number"
                  style={{ color: pizarra.color }}
                >
                  {pizarra.number}
                </div>
              )}
            </div>

            {pizarraConfig.showScores && (
              <div 
                className="pizarra-score"
                style={{ color: pizarra.color }}
              >
                {pizarra.score} puntos
              </div>
            )}
          </div>
        ))}
      </div>
      
    </div>
  );
};

export default PizarraPage;
